import { Component, Input } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { LabelDetailDto } from '@artemis-software/wr-api';
import DimensionEnum = LabelDetailDto.DimensionEnum;

@Component({
  standalone: false,
  selector: 'wr-dimension-select',
  templateUrl: './dimension-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: DimensionSelectComponent,
      multi: true,
    },
  ],
})
export class DimensionSelectComponent extends AbstractFormControl<DimensionEnum> {
  readonly values = Object.values(DimensionEnum);

  @Input()
  placeholder = 'Dimension auswählen';
}
